import React, { useCallback, useEffect, useState } from 'react';

interface ConfigType<T> {
  hiddenElement: React.RefObject<T> | string;
  targetElement: React.RefObject<T> | string;
  additionalOptions?: {
    flag?: boolean;
  };
}

function useHideElementIntersection<T extends HTMLElement>(
  config: ConfigType<T>
): [boolean] {
  const [isShowFixedPanel, setStatusFixePanel] = useState(false);

  const getHiddenElementBySelector = useCallback(
    (selector: string) => document.querySelector(selector),
    []
  );

  const getElement = useCallback(
    <T extends HTMLElement>(selector: ConfigType<T>['targetElement']) => {
      return typeof selector !== 'string'
        ? selector.current
        : getHiddenElementBySelector(selector);
    },
    [getHiddenElementBySelector]
  );

  useEffect(() => {
    if (config.additionalOptions?.flag !== undefined) {
      if (config.additionalOptions.flag) {
        const hiddenElement = getElement(config.hiddenElement);
        const targetElement = getElement(config.targetElement);

        if (!hiddenElement || !targetElement) return;

        const heightHiddenElement =
          hiddenElement.getBoundingClientRect().height;

        function onScroll() {
          if (targetElement) {
            const bottomFooterElement =
              targetElement.getBoundingClientRect().bottom;
            const windowInnerHeight = window.innerHeight;

            if (
              bottomFooterElement < heightHiddenElement + windowInnerHeight ||
              window.scrollY < 900
            ) {
              setStatusFixePanel(false);
            } else {
              setStatusFixePanel(true);
            }
          }
        }

        document.addEventListener('scroll', onScroll);

        onScroll();

        return () => {
          document.removeEventListener('scroll', onScroll);
        };
      }
    }
  }, [
    config.additionalOptions?.flag,
    config.hiddenElement,
    config.targetElement,
    getElement,
  ]);

  return [isShowFixedPanel];
}

export default useHideElementIntersection;
